import { Device } from '@weenat/client/dist/resources/devices'
import { Plot } from '@weenat/client/dist/resources/plots'
import { useIntl } from '@weenat/wintl'
import { useOrgContext } from 'app/orgProvider'
import { useNavigate } from 'app/routx-router'
import Icons from 'app/src/kit/Icons'
import InteractiveCard from 'app/src/kit/InteractiveCard'
import Text from 'app/src/kit/Text'
import { isEmpty, isNil } from 'lodash-es'
import { styled } from 'styled-components'

const PressableCard = styled(InteractiveCard)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${(p) => p.theme.spacings.md}px;
  gap: ${(p) => p.theme.spacings.md}px;
  border-radius: ${(p) => p.theme.spacings.md}px;
`

interface LinkedPlotLinkItemProps {
  plot: Plot
  device: Device
}

const LinkedPlotLinkItem: FC<LinkedPlotLinkItemProps> = ({ plot, device }) => {
  const nav = useNavigate()
  const org = useOrgContext()
  const { formatRelativeTimeToNow } = useIntl()

  const { currentMeasurementConfigs } = plot

  const matchingConfig = !isEmpty(currentMeasurementConfigs)
    ? currentMeasurementConfigs.find(
        (conf) => !isNil(conf.deviceId) && isNil(conf.endDate) && device.id === conf.deviceId
      )
    : undefined

  return (
    <PressableCard onPress={() => nav(`/farms/${org.id}/plots/${plot.id}`)}>
      <Icons.PlotsFilled $size='lg' />
      <Box $flex={1} $minWidth={0}>
        <Text $fontWeight='bold'>{plot.name}</Text>
        <Flex $alignItems='center' $gap={'sm'}>
          <Text $fontSize='sm'>{plot.reverseGeocoding}</Text>
          <Text $fontSize='sm'>·</Text>
          <Text $fontSize='sm'>{formatRelativeTimeToNow(matchingConfig?.startDate)}</Text>
        </Flex>
      </Box>
      <Icons.ArrowRight $size='lg' />
    </PressableCard>
  )
}

export default LinkedPlotLinkItem
